import React, { FC, ReactNode } from "react";
import * as ReactModal from "react-modal";
import { SvgIcon } from "../SvgIcon/SvgIcon";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  className?: string;
  overlayClassName?: string;
  withoutCloseBtn?: boolean;
  children: ReactNode;
}

export const Modal: FC<ModalProps> = (props) => {
  const { isOpen, onClose, children, className, overlayClassName } = props;

  ReactModal.setAppElement("body");

  return (
    <ReactModal
      className={className}
      overlayClassName={overlayClassName}
      isOpen={isOpen}
      shouldCloseOnEsc
      onRequestClose={onClose}
    >
      <button onClick={onClose} className="close-btn">
        <SvgIcon iconName="close" />
      </button>
      {children}
    </ReactModal>
  );
};
